import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient from '../httpClient';

export const usePorte = () => {
  const [porte, setPorte] = useState<EnumOption[]>([]);

  useEffect(() => {
    const fetchPorte = async () => {
      try {
        const response = await httpClient.get(`/api/fornecedor/porte`);

        const options = response.data.map(
          (porte: { value: number; label: string }) => ({
            value: porte.value.toString(),
            label: porte.label,
          }),
        );
        setPorte(options);
      } catch (error) {
        console.error('Erro ao buscar Porte', error);
      }
    };

    fetchPorte();
  }, []);

  return porte;
};
